import React, { useEffect, useContext, useState, Suspense } from "react"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import { GlobalContext } from "@Context/context/GlobalState"
import { getOrderDetails } from "@Services/orderService"
import { useEnv } from "@Hooks"
import CardTravelIcon from "@material-ui/icons/CardTravel"
import { useTranslation } from "react-i18next"
import rsc from "@Config/resources"
import { useHistory } from "react-router"

import { LoadComponentByCondition } from "@Methods"
const Component = new LoadComponentByCondition("DetailOrder").render()

const ShowOrderScreen = () => {
  const { id } = useParams()
  const user = useEnv().multiclient.get_user()
  const { handleRoutingBreadcrumbs, handleErrorSession } =
    useContext(GlobalContext)
  const [info, setInfo] = useState({})
  const [load, setLoad] = useState(true)
  const { t } = useTranslation("global")
  const history = useHistory()
  const { multiclient } = useEnv()

  useEffect(() => {
    if (
      !multiclient.permissions_v3_on(
        [rsc.ORDERS, rsc.ORDER_BUTTON_SHOW],
        [rsc.OrListOrder, rsc.ORDER_LIST_ORDER_LIST],
      )
    ) {
      return history.goBack()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    handleRoutingBreadcrumbs({
      titleHeader: t("detail-orders"),
      routes: [
        { name: t("order"), route: "/order/new" },
        { name: t("detail-orders"), route: `/order/${id}` },
      ],
      icon: <CardTravelIcon style={{ marginRight: 5, opacity: 0.5 }} />,
    })
    setLoad(true)
    loadDataOrder()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const loadDataOrder = async () => {
    try {
      let response = await getOrderDetails(user?.token, id)
      setInfo(response.data.message)
      setLoad(false)
    } catch (error) {
      handleErrorSession({
        error: true,
        errorCode: error.response.status,
        messageError: error?.response?.data?.message,
      })
    }
  }

  return (
    <Suspense fallback>
      <Component load={load} info={info} />
    </Suspense>
  )
}

export default ShowOrderScreen
